import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React, { ReactNode } from 'react';
import { IntergrationInstructionContent, IntergrationInstructionStep, StrVal } from '../services/api/types';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import StepInput from './StepInput';
import { P2GImage } from '@parcel2go/peacock-legacy-core/dist/image';

interface props {
  step: IntergrationInstructionStep;
  stepNumber: number;
  showInstructions: boolean;
  showNumber: boolean;
  saving: boolean;
  values: StrVal;
  onUpdate: (key: string, value: string) => void;
}

export function Content(props: IntergrationInstructionContent) {
  switch (props.elementType) {
    case 'Image':
      return <P2GImage style={{ width: '100%' }} src={props.attributes['src']} alt={props.attributes['alt']} />;
    case 'UnOrderedList':
      return (
        <ul>
          {props.childElements.map((c) => (
            <li key={c.content}>
              <P2GBox pt={1} pb={1}>
                <P2GText variant="body2">{c.content}</P2GText>
              </P2GBox>
            </li>
          ))}
        </ul>
      );
    default:
      return <P2GText variant="body2">{props.content}</P2GText>;
  }
}

export function StepRow(props: { left: ReactNode; right: ReactNode }) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2}>
      {props.left && (
        <P2GGrid item xs={1}>
          {props.left}
        </P2GGrid>
      )}
      <P2GGrid item xs={12}>
        {props.right}
      </P2GGrid>
    </P2GGrid>
  );
}

export default function Step(props: props) {
  return (
    <StepRow
      left={props.showNumber && <P2GText variant="h2">{props.stepNumber}</P2GText>}
      right={
        <>
          {props.showInstructions && (
            <P2GBox mb={2}>
              {props.step.content.map((c, i) => (
                <P2GBox key={c.content} mt={i > 0 ? 1 : 0}>
                  <Content {...c} />
                </P2GBox>
              ))}
            </P2GBox>
          )}
          {props.step.inputs?.length > 0 && (
            <P2GGrid container spacing={2} direction="column">
              {props.step.inputs.map((i) => (
                <P2GGrid item xs={12}>
                  <StepInput
                    disabled={props.saving}
                    input={i}
                    value={props.values[i.propertyName]}
                    onUpdate={props.onUpdate}
                  />
                </P2GGrid>
              ))}
            </P2GGrid>
          )}
        </>
      }
    />
  );
}
